require("./css/sass/main.everything.scss");
//require("./css/sass/print.scss");

// node modules
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
window.FontFaceObserver = require('fontfaceobserver/fontfaceobserver.js');

require('bootstrap');
require('jquery-validation');
require('jquery-validation/dist/additional-methods');
window.AOS = require('aos');

const { Dropzone } = require('dropzone');
// window.zxcvbn = require('zxcvbn'); // too huge for sitewide include
// require('@lottiefiles/lottie-player'); // breaks IE - include separately instead


// libraries
window.wNumb = require("./libs/wNumb/wNumb.min.js");
window.noUiSlider = require("./libs/nouislider/nouislider.min.js");
require("./libs/jquery-ui/jquery-ui-custom.min.js");
require("./libs/slick/slick.min.js");
require("./libs/jquery-mask/jquery.mask.min.js");
require("./libs/easy-autocomplete/jquery.easy-autocomplete.js");
// require("./libs/datatables/jquery.dataTables.1.12.1.min.js");

// site specific
require("./js/common.js");
require("./js/central.js");